import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import API from './const.js';
import { QueryNames } from './hooks/queryNames.js';

const useSendWhatsappOTP = () => {
    const { GET } = useVahakHttpClient();
    function sendWaOTP(params) {
        const { phoneNumber } = params;
        return GET(API.OTP_VIA_WHATSAPP + phoneNumber);
    }
    return useVahakMutationQuery([QueryNames.auth.sendWaOTP], sendWaOTP);
};

export { useSendWhatsappOTP };
//# sourceMappingURL=whatsapp-otp.service.js.map
